import { z } from 'zod'
import {
  type AssistantActionKey,
  type AssistantChangePayload,
  assistantChangePayloadSchema,
  parseAssistantJson,
} from '../../assistantSchemas'

/**
 * 複合Action keyを比較用文字列へ変換する。
 * @param params source IDとAction order。
 * @returns split不要で衝突しないJSON表現。
 */
export const createAssistantActionKeyValue = ({
  sourceId,
  actionOrder,
}: AssistantActionKey): string => JSON.stringify([sourceId, actionOrder])

/**
 * 保存済み共通change payloadをJSON parse後にZod検証する。
 * @param params changePayloadJson。
 * @returns 許可列だけを含む検証済みpayload。
 */
export const parseAssistantChangePayloadJson = ({
  changePayloadJson,
}: {
  readonly changePayloadJson: string
}): AssistantChangePayload =>
  assistantChangePayloadSchema.parse(
    parseAssistantJson({ json: changePayloadJson }),
  )

/**
 * rule固有JSONが構文上有効なobjectであることだけをDB境界で検証する。
 * @param params JSON文字列とエラー上の用途名。
 * @returns parse済みobject。
 */
export const parseAssistantJsonObject = ({
  json,
  label,
}: {
  readonly json: string
  readonly label: string
}): Record<string, unknown> => {
  const value = parseAssistantJson({ json })
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new Error(`${label} must be a JSON object`)
  }
  return z.record(z.unknown()).parse(value)
}
